import * as React from "react";
import { Indent } from "@stenajs-webui/core";
import { Icon, stenaArrowRight } from "@stenajs-webui/elements";
import { cssColor } from "@stenajs-webui/theme";

interface Props {}

export const ModifiedFieldSeparator: React.FC<Props> = () => {
  return (
    <Indent num={0.5}>
      <Icon
        icon={stenaArrowRight}
        size={10}
        color={cssColor("--lhds-color-ui-700")}
      />
    </Indent>
  );
};
